import clsx from 'clsx';

type DividerProps = {
  orientation?: 'horizontal' | 'vertical';
  length?: string; // e.g., '50%', '200px'
  className?: string;
};

export function Divider({
  orientation = 'horizontal',
  length = '100%',
  className = '',
}: DividerProps) {
  return (
    <div
      className={clsx(
        'bg-gray-5 mx-auto',
        orientation === 'horizontal' ? 'h-[1px]' : 'w-[1px] h-full my-auto',
        className
      )}
      style={
        orientation === 'horizontal' ? { width: length } : { height: length }
      }
    />
  );
}
